import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
  Checkbox,
  Select,
  FormControl,
  InputLabel,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BASE_URL } from "../../urlConfig/Url";

const UserMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [plantCode, setPlantCode] = useState("");
  const [email, setEmail] = useState("");
  const [id, setID] = useState("");
  const [userRole, setUserRole] = useState([]);
  const [userType, setUserType] = useState(""); // Assuming userType is a placeholder
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [mobile, setMobile] = useState("");
  const [locked, setLocked] = useState("");
  const [passExpDay, setPassExpDay] = useState("");
  const [status, setStatus] = useState("");
  const [webAcssess, setWebAccess] = useState("");
  const [hhtAccess, setHhtAccess] = useState("");
  const [companies, setCompanies] = useState([]);
  const [cName, setCName] = useState([]);
  const [cTwoName, setCTwoName] = useState([]);

  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [orderDirection, setOrderDirection] = useState("asc"); // 'asc' or 'desc'
  const [orderBy, setOrderBy] = useState("");
  const [paginatedRows, setPaginatedRows] = useState([]);

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
    fetchCompaniesTwo();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/role/getUserAllUserList"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/master/getPlantCode");
      if (response.data.success) {
        setCName(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesTwo = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/role/getUserRoleAll");
      if (response.data.success) {
        setCTwoName(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const onSubmit = async () => {
    if (password !== confirmPassword) {
      toast.error("plz check the confirm password !!!");
      return;
    }
    const data = {
      User_ID: userId.trim(),
      User_Name: userName,
      User_Password: password.trim(),
      User_Role: userRole,
      Status: status,
      Web_MenuAccess: webAcssess,
      HHT_MenuAccess: hhtAccess,
      Locked: locked,
      PassExpDays: passExpDay,
      LoginAttempt: 0,
      Name: userName,
      PlantCode: plantCode,
      EmailId: email,
      MobileNo: mobile,
      CreatedBy: getName().Name,
    };
    // console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/admin/registerUserRole",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  };

  const onUpdate = async () => {
    if (password === "") {
      toast.error("Please Fill the Password !!");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("plz check the confirm password !!!");
      return;
    }
    const data = {
      ID: id,

      UserName: userName,
      User_Password: password,
      User_Role: userRole,
      Status: status,
      Web_MenuAccess: webAcssess,
      HHT_MenuAccess: hhtAccess,
      Locked: locked,
      PassExpDays: passExpDay,
      PlantCode: plantCode,
      EmailId: email,
      MobileNo: mobile,
      UpdatedBy: getName().Name,
    };
    //   console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/admin/updateUser",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setID("");
    setUserRole([]); // Reset to an empty array
    setUserType("");
    setPlantCode("");
    setUserName("");
    setUserId("");
    setEmail("");
    setMobile("");
    setLocked("");
    setPassExpDay("");
    setStatus("");
    setPassword("");
    setConfirmPassword("");
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
  };

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    const result = companies.filter((company) =>
      searchWords.every((word) =>
        Object.entries(company).some(([key, value]) => {
          // Skip null or undefined values
          if (value == null) return false;
  
          // Convert to string and compare
          return value.toString().toLowerCase().includes(word);
        })
      )
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
      setPage(1);
    };

  // const handleSearchChange = (event) => {
  //   const term = event.target.value.toLowerCase();
  //   setSearchTerm(term);

  //   const filteredData = companies.filter((company) => {
  //     // Check each field that you want to search within
  //     return (
  //       company.User_ID.toLowerCase().includes(term) ||
  //       company.User_Name.toLowerCase().includes(term) ||
  //       company.User_Role.toLowerCase().includes(term) ||
  //       company.Locked.toLowerCase().includes(term) ||
  //       company.PassExpDays.toString().includes(term) || // Convert number to string
  //       company.PlantCode.toLowerCase().includes(term) ||
  //       company.EmailId.toLowerCase().includes(term) ||
  //       company.MobileNo.toString().includes(term) // Convert number to string
  //     );
  //   });

  //   setFilteredRows(filteredData);
  //   setPage(1); // Reset to first page whenever search changes
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowSelect = (company) => {
    setPlantCode(company.PlantCode);
    setEmail(company.EmailId);
    setID(company.ID);
    setUserRole(company.User_Role);
    setUserType(company.UserType);
    setUserName(company.User_Name);
    setUserId(company.User_ID);
    setMobile(company.MobileNo);
    setLocked(company.Locked);
    setPassExpDay(company.PassExpDays);
    setStatus(company.User_Status);
    setWebAccess(company.Web_MenuAccess);
    setHhtAccess(company.HHT_MenuAccess);
    // setPassword("")
    // setConfirmPassword("")

    setFormMode("edit");
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  //   const paginatedRows = filteredRows.slice(
  //     (page - 1) * rowsPerPage,
  //     page * rowsPerPage
  //   );

  useEffect(() => {
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = page * rowsPerPage;
    setPaginatedRows(filteredRows.slice(startIndex, endIndex));
  }, [filteredRows, page, rowsPerPage]);

  // ================================= Password view ==========================
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  // ================================= Password view ==========================

  //   ====================================Selected dropdown list data console ================
  const handleUserRoleChange = (e) => {
    const selectedRole = e.target.value;
    setUserRole(selectedRole);

    const selectedItem = cTwoName.find(
      (item) => item.UserType === selectedRole
    );
    setWebAccess(selectedItem.Web_MenuAccess);
    setHhtAccess(selectedItem.HHT_MenuAccess);
    // console.log("Selected Role:", selectedRole);
    // console.log("Selected Item:", selectedItem.Web_MenuAccess);
  };

  //   =============================Sort Handler ==================================
  const handleSortRequest = (column) => {
    const isAsc = orderBy === column && orderDirection === "asc";
    setOrderDirection(isAsc ? "desc" : "asc");
    setOrderBy(column);
    const sortedRows = [...paginatedRows].sort((a, b) => {
      if (a[column] < b[column]) {
        return isAsc ? -1 : 1;
      }
      if (a[column] > b[column]) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setPaginatedRows(sortedRows);
  };

  return (
    <>
      <Container maxWidth={isMobile ? "xs" : "lg"}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <Box sx={{ mt: 1, mb: 2 }}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  to="/dashboard/dashbordhome"
                  style={{
                    textDecoration: "none",
                    color: theme.palette.primary.main,
                  }}
                >
                  Home
                </Link>
                <Typography color="textPrimary">User Master</Typography>
              </Breadcrumbs>
            </Box>

            <Paper elevation={3} sx={{ padding: "2%" }}>
              <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
                User Master (* Fields Are Mandatory)
              </Typography>

              <Grid container spacing={3} alignItems="center">
                {/* <Grid item xs={12} sm={3}>
                  <TextField
                    label="User Role (*)"
                    name="User Role"
                    fullWidth
                    size="small"
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                    disabled={formMode === "initial"}
                  />
                </Grid> */}
                <Grid item xs={12} sm={3}>
                  <TextField
                    select
                    label="Plant Code (*)"
                    name="Plant Code"
                    fullWidth
                    size="small"
                    value={plantCode}
                    onChange={(e) => setPlantCode(e.target.value)}
                    disabled={formMode === "initial"}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {cName.map((company) => (
                      <MenuItem
                        key={company.PlantCode}
                        value={company.PlantCode}
                      >
                        {company.PlantCode}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    select
                    label="User Type/Role (*)"
                    name="Plant Code"
                    fullWidth
                    size="small"
                    value={userRole}
                    onChange={handleUserRoleChange}
                    disabled={formMode === "initial"}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {cTwoName.map((item) => (
                      <MenuItem key={item.U_ID} value={item.UserType}>
                        {item.UserType}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <TextField
                    label="User Name (*)"
                    name="User Name"
                    fullWidth
                    size="small"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    disabled={formMode === "initial"}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="User ID (*)"
                    name="User ID"
                    fullWidth
                    size="small"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    disabled={formMode === "initial" || formMode === "edit"}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Email Id (*)"
                    name="Email Id"
                    fullWidth
                    size="small"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={formMode === "initial"}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Mobile No "
                    name="Mobile No"
                    fullWidth
                    size="small"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    disabled={formMode === "initial"}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Password (*)"
                    name="Password"
                    fullWidth
                    size="small"
                    type={showPassword ? "text" : "password"} // Toggle between "text" and "password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={formMode === "initial"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleTogglePasswordVisibility}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Confirm Password (*)"
                    name="Confirm Password"
                    fullWidth
                    size="small"
                    type={showConfirmPassword ? "text" : "password"} // Toggle between "text" and "password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    disabled={formMode === "initial"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle confirm password visibility"
                            onClick={handleToggleConfirmPasswordVisibility}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    select
                    label="Locked(*)"
                    name="Locked"
                    fullWidth
                    size="small"
                    value={locked}
                    onChange={(e) => setLocked(e.target.value)}
                    disabled={formMode === "initial"}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Password Exp Days (*)"
                    name="Password Exp Days"
                    fullWidth
                    size="small"
                    value={passExpDay}
                    onChange={(e) => setPassExpDay(e.target.value)}
                    disabled={formMode === "initial"}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    select
                    label="Status(*)"
                    name="Status"
                    fullWidth
                    size="small"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    disabled={formMode === "initial"}
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="De-Active">De-Active</MenuItem>
                  </TextField>
                </Grid>
              </Grid>

              <Grid container justifyContent="flex-end" mt={5} spacing={1}>
                {formMode === "initial" && (
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleAddNew}
                    >
                      <AddIcon />
                      Add New
                    </Button>
                  </Grid>
                )}

                {formMode === "add" && (
                  <>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={onSubmit}
                      >
                        <AddIcon />
                        Submit
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleCancel}
                      >
                        <CloseIcon />
                        Cancel
                      </Button>
                    </Grid>
                  </>
                )}

                {formMode === "edit" && (
                  <>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={onUpdate}
                      >
                        <ChangeCircleIcon />
                        Update
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleCancel}
                      >
                        <CloseIcon />
                        Cancel
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Paper>

            {/* Table section */}
            <Paper elevation={3} sx={{ padding: "2%", mt: 3 }}>
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "stretch" : "center",
                  gap: 2,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  sx={{ minWidth: 100 }}
                >
                  <InputLabel id="rows-per-page-label">
                    Rows per page
                  </InputLabel>
                  <Select
                    labelId="rows-per-page-label"
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                    label="Rows per page"
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  sx={{ width: isMobile ? "100%" : 250 }}
                  InputProps={{
                    endAdornment: (
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Box>

              <Box
                sx={{
                  overflowX: "auto",
                  maxWidth: "100%",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Select</TableCell>
                      <TableCell onClick={() => handleSortRequest("User_ID")}>
                        User ID{" "}
                        {orderBy === "User_ID"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell onClick={() => handleSortRequest("User_Name")}>
                        User Name{" "}
                        {orderBy === "User_Name"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell onClick={() => handleSortRequest("User_Role")}>
                        Role{" "}
                        {orderBy === "User_Role"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell onClick={() => handleSortRequest("Locked")}>
                        Locked Status{" "}
                        {orderBy === "Locked"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell
                        onClick={() => handleSortRequest("PassExpDays")}
                      >
                        Pass Exp Days{" "}
                        {orderBy === "PassExpDays"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell onClick={() => handleSortRequest("PlantCode")}>
                        Plant Code{" "}
                        {orderBy === "PlantCode"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell onClick={() => handleSortRequest("EmailId")}>
                        Email ID{" "}
                        {orderBy === "EmailId"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                      <TableCell onClick={() => handleSortRequest("MobileNo")}>
                        Phone{" "}
                        {orderBy === "MobileNo"
                          ? orderDirection === "asc"
                            ? "↑"
                            : "↓"
                          : ""}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedRows.map((company) => (
                      <TableRow key={company.ID}>
                        <TableCell>
                          <Button
                            size="small"
                            onClick={() => handleRowSelect(company)}
                          >
                            Select
                          </Button>
                        </TableCell>
                        <TableCell>{company.User_ID}</TableCell>
                        <TableCell>{company.User_Name}</TableCell>
                        <TableCell>{company.User_Role}</TableCell>
                        <TableCell>{company.Locked}</TableCell>
                        <TableCell>{company.PassExpDays}</TableCell>
                        <TableCell>{company.PlantCode}</TableCell>
                        <TableCell>{company.EmailId}</TableCell>
                        <TableCell>{company.MobileNo}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "stretch" : "center",
                  gap: 2,
                }}
              >
                <Typography variant="body2">
                  Showing {(page - 1) * rowsPerPage + 1} to{" "}
                  {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                  {filteredRows.length} entries
                </Typography>
                <Pagination
                  count={Math.ceil(filteredRows.length / rowsPerPage)}
                  page={page}
                  onChange={handleChangePage}
                  size="small"
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default UserMaster;
